export class AuthStaticToken {
  constructor(readonly token: string) {}

  isValid() {
    return !!this.token;
  }
}
